module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/faq-e4be10cf1c3d6db83e5998f29f608b5f.webp";